module.exports = __webpack_public_path__ + "03_long_brown.34a3337e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer5/03_long_brown.png
// module id = tYPA
// module chunks = 0